import WSJ_PRINT_GRID from '../constants/wsj-print-grid';
import FN_PRINT_GRID from '../constants/fn-print-grid';
import BARRONS_PRINT_GRID from '../constants/barrons-print-grid';

export function getGrid(id) {
  switch (id) {
    case 'print-wsj':
      return WSJ_PRINT_GRID;
    case 'print-fnlondon':
      return FN_PRINT_GRID;
    case 'print-barrons':
      return BARRONS_PRINT_GRID;
  }
}

export function convertWidthHeight(id, prop, value) {
  const grid = getGrid(id);
  switch (prop) {
    case 'width':
      const col1 = grid.columns[0];
      const delta = grid.columns[1] - grid.columns[0];
      const idx = Math.round((value - col1) / delta);
      return { width: grid.columns[idx], cols: idx + 1 };
    case 'height':
      return { lines: Math.round(value / grid.line) };
    case 'lines':
      return { height: (value * grid.line).toFixed(1) };
  }
}
